export const defaultTemplate = (user: any, firm: any) => {
  return `   

    Type your message here...

  `;
};

export const beforeTemplate = (firm: any) => {
  return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Email Template</title>
</head>
<body>
    <div class="email-container" style="background-color:rgb(229, 229, 229); width:100%;">
        <div class="content-container" style="width:90%;background-color:rgb(255, 255, 255);margin-top:20px;margin-bottom:20px;margin-left:auto;margin-right:auto;">
            <!-- Header Section with Thrive Logo -->
            <div class="header" style="margin:20px;background-color:#9d2362;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0;width:100%;background-color:#9d2362;">
                    <tbody>
                        <tr>
                            <td style="width:96px;height:60px;background-color:#9d2362;">
                                <img alt="Thrive Logo" src="https://www.thrive-drive.org:8443/images/Thrive_logo.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:96px;height:43px;font-size:13px;" title="Thrive Logo" width="140">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <!-- Content Section -->
            <div class="content" contenteditable="true" style="margin:20px;" role="replace">
            `;
};

export const afterTemplate = (user: any, firm: any) => {
  return `
            </div>
            <hr>

            <!-- SBC Signature Section -->
            <div class="sbc-signature" style="margin:20px;">
                <p style="margin: 0 0 10px 0; font-size: 16px; color: #333333; line-height: 1.6;">
                    <strong>${user.firstName} ${user.lastName}</strong>
                </p>
                <p>
                    <em>${user.title}</em>
                </p>
                <p style="margin:0 0 5px 0;">
                    <a href="tel:${
                      user.phone
                    }" style="color: #007bff; text-decoration: none;">${
    user.phone
  }</a>
                </p>
                <p style="margin:0 0 5px 0;">
                    <a href="mailto:${
                      user.email
                    }" style="color: #007bff; text-decoration: none;">${
    user.email
  }</a>
                </p>
                <a href="${
                  user.meeting_url
                    ? user.meeting_url
                    : "https://outlook.office365.com/owa/calendar/OaklandThriveClintMeetingPage@NETORGFT13100098.onmicrosoft.com/bookings/"
                }">Click to Schedule Your Consultation!</a>
            </div>

            <!-- Footer Section -->
            <div class="footer" style="padding:20px; background-color:#f8f9fa; text-align:center;">
                <div class="social-links" style="width:100%;margin:0 auto;text-align:left;">
                    <a href="https://www.facebook.com/oaklandthrive" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                    <a href="https://x.com/OaklandThrive" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn.gifo.wisestamp.com/s/tw/55acee/48/0/background.png" alt="X" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                    <a href="https://www.linkedin.com/company/oakland-thrive" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733561.png" alt="LinkedIn" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                    <a href="https://www.instagram.com/oaklandthrive/" style="display:inline-block; margin:0 10px; color:#9d2362; text-decoration:none;">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733558.png" alt="Instagram" width="24" style="width:24px; max-width:100%; height:24px; vertical-align:middle; margin-right:5px;">
                    </a>
                </div>
                <div style="float:left;width:100%;margin:10px;text-align:left;">
                    <a href="https://thrive-drive.org/case?id=${
                      firm.openCase
                    }" style="color:#9d2362; text-decoration:none;">reference#:${
    firm.openCase
  }</a>
                </div>
                
                <p style="color:#666666; font-size:14px; margin:5px 0;"><strong>Oakland Thrive</strong></p>
                <p style="color:#666666; font-size:14px; margin:5px 0;">35 W Huron St., Suite 201 Pontiac, MI 48342</p>
                
                <p style="color:#666666; font-size:14px; margin:5px 0;">© 2025 Oakland Thrive. All rights reserved.</p>
                
                <p style="color:#666666; font-size:14px; margin:5px 0;">
                    <a href="https://www.thrive-drive.org/unsubscribe/${
                      firm._id
                    }" style="color:#9d2362; text-decoration:none;">Unsubscribe</a>
                </p>
            </div>
        </div>
    </div>
</body>
</html>`;
};

export const DirectEmailEmptyBody = (
  user: any,
  firm: any,
  theCase: any,
  referral: any,
  provider: any,
  resource: any,
  event: any,
  template_block: any
) => {
  const htmlbody = `
    ${beforeTemplate(firm)}
    ${defaultTemplate(user, firm)}
    ${afterTemplate(user, firm)}`;
  return htmlbody;
};
